import request from "@/utils/request";

/**
 * 账户详情
 */
export const accountDetailsApi = () =>
  request.get({
    url: "account/index",
  });

// type AddBankCardOptions = {
//     accountId: number
//     bankCode: string
//     bankOriginalName: string
//     bankUserName: string
//     captcha: string
//     bankIdCard: string
//     [key: string]: any
// }

/**
 * 添加银行卡
 */
export const addBankCardApi = (data) => {
  return request.post({
    url: "account/addBankCard",
    data,
  });
};

/**
 * 获取绑定银行卡验证码
 */
export const getCaptchaApi = () => {
  return request.post({
    url: "account/captcha",
  });
};

/**
 * 绑定支付密码
 */
export const updatePwApi = (data) => {
  return request.post({
    url: "account/updatePPW",
    data,
  });
};

/**
 * 删除银行卡
 */
export const deleteBankCardApi = (id) => {
  return request.post({
    url: `account/deleteBankCard/${id}`,
  });
};

// type FinancialDetailsApiOptions = {
//     /** 账户id */
//     accountId: number
//     limit: number
//     page: number
// }

/**
 * 财务明细
 */
export const financialDetailsApi = (data) => {
  return request.get({
    url: "account/records",
    data,
  });
};

/**
 * 提现
 */
export const withdrawalApi = (data) => {
  return request.post({
    url: "account/drawableMoney",
    data,
  });
};

/**
 * 提现记录
 */
export const withdrawalRecordApi = (data) => {
  return request.get({
    url: "account/drawable/records",
    data,
  });
};

/**
 * 积分记录
 */
export const pointRecordsApi = (data) => {
  return request.get({
    url: "account/point_records",
    data,
  });
};

/*type JoinInOptions = {
    /!** 农场信息 *!/
    adminFarmInfo: {
        /!** 农场地址 *!/
        address: string
        /!** 营业执照 *!/
        businessLicensePics: string
        /!** 城市 *!/
        city: string
        /!** 店铺详情 *!/
        detail: string
        /!** 农场logo *!/
        farmLogo: string
        /!** 农场类型 *!/
        farmType?: 1 | 2
        /!** 身份证照片 *!/
        idCardPics: string
        /!** 姓名 *!/
        name: string
        /!** 农场主名称 *!/
        ownerName: string
        /!** 手机号 *!/
        phone: string
    }
    /!** 店铺信息 *!/
    adminStoreInfo: {
        /!** 账户 *!/
        adminOwnerAccount: string
        /!** 账户密码 *!/
        adminPassword: string
        /!** 保证金 *!/
        earnestMoney?: number
        isDrawableMoney?: number
        isPayEarnestMoney?: number
        /!** 弄成猪名称 *!/
        ownerName: string
        /!** 身份证 *!/
        storeIdCard: string
        /!** logo *!/
        storeLogo: string
        /!** 店铺名称 *!/
        storeName: string
        /!** 手机号 *!/
        storePhone: string
        /!** 状态 *!/
        storeStatus?: number
        /!** 店铺类型 1 个人 2 企业 *!/
        storeType: 1 | 2
    }
    captcha: string
    mobile: string
}*/
/**
 * 入驻
 */
export const joinInApi = (data) => {
  return request.post({
    url: "account/add_store",
    data,
  });
};

/** 店铺详情 */
export const farmInfoApi = (id) => {
  return request.get({
    url: `account/farmInfo/${id}`,
  });
};

/** 店铺销量 */
export const farmOrderTotalApi = (id) => {
  return request.get({
    url: `account/countSales/${id}`,
  });
};

/** 根据手机号发送验证码 */
export const sendCodeToPhoneApi = (mobile) => {
  return request.post({
    url: "account/captcha_by_phone",
    data: mobile,
  });
};

/**
 * 用户直播设备列表
 * page: number; ---页码
 * limit: number; --- 每页条数
 * columnType?: string; ---直播类型 1店铺，2景区，3农业，4道路，5餐饮，6幼儿园
 * userId?: number; --- 用户id  --查询某个用户的直播设备时传入
 * approvalStatus?: number; --- 审核状态 0待审核，1已通过，2未通过 --不传时查询所有
 */
export const LiveHostListApi = (data) => request.post({
  url: 'device/list?page=' + data.page + '&limit=' + data.limit + '&userId=' + data.userId,
})

/**
 * 删除直播设备
 * @param id 直播设备id
 * @returns
 */
export const LiveHostDelApi = (id) => request.post({
  url: `device/del?id=${id}`
})

/**
 *
 * @returns 获取会员卡列表
 */
export const vipCardListApi = () => request.get({
  url: 'vip/list'
})

/**
 * 某一设备授权列表
 */
export const LiveHostAuthListApi = (data) => request.get({
  url: `device/authorizeList`,
  data
})

/**
 * 添加授权
 */
export const addAuthInfoApi = (data) => request.post({
  url: 'device/addAuthorize',
  data
})
/**
 * 编辑授权
 */
export const editAuthInfoApi = (data) => request.post({
  url: 'device/updateAuthorize',
  data
})
/**
 * 获取授权详情
 */
export const authInfoDetailsApi = (phone, id) => request.get({
  url: `device/authorizeDetail?deviceId=${id}&phone=${phone}`
})
/**
 * 删除设备某个手机号的授权
 */
export const delPhoneAuthApi = (data) => request.post({
  url: 'device/delAuthorize',
  data
})
/**
 * 添加直播设备
 */
export const LiveHostAddApi = (data) => request.post({
  url: "device/add",
  data
})
/**
 * 修改直播设备信息
 * @param data
 * @returns
 */
export const LiveHostEditApi = (data) => request.post({
  url: "device/update",
  data
})

/**
 * 获取直播设备详情
 */
export const LiveHostInfoApi = (id) => request.get({
  url: `device/get?id=${id}`
})
/**
 * 获取消息统计
 */
export const getMessageStatistics = () =>
  request.get({
    url: "message/messageStatistics"
  })

/**
 * 分页获取消息列表
 * @param params 查询参数
 */
export const getMessagePage = (params) => {
  let url = "message/getPage?page=" + params.page + "&limit=" + params.limit
  if (params.read !== undefined && params.read !== null) {
    url += "&read=" + params.read;
  }
  return request.get({ url });
}

/**
 * 获取单条消息详情并标记为已读
 * @param id 消息ID
 */
export const getMessageDetail = (id) =>
  request.get({
    url: "message/getMessage",
    data: { id }
  })
